module.exports = __webpack_public_path__ + "static/media/add.8f4d0b3a.jpg";